/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Value_Safety_TextInputs */



/**
* | output |
* | --- |
* | "Working towards a safer industry by sharing what we learn." |
*
* @param {About_Value_Safety_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_value_safety_text = /** @type {((inputs?: About_Value_Safety_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Value_Safety_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("分享我们的经验，推动行业更加安全。")
	return /** @type {LocalizedString} */ ("Working towards a safer industry by sharing what we learn.")
});